export default __webpack_public_path__ + "static/media/cathedral.ff40bcf4.jpg";